import React from "react";

const Employee = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-employee"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-employee"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m19,6h0c0,.552-.448,1-1,1H6c-.552,0-1-.448-1-1h0c0-.552.448-1,1-1h.023C6.262,2.365,8.366.261,11,.023v2.977c0,.552.448,1,1,1h0c.552,0,1-.448,1-1V.023c2.634.239,4.738,2.343,4.977,4.977h.023c.552,0,1,.448,1,1Zm-12.998,3.146c.078,3.241,2.738,5.854,5.998,5.854s5.92-2.613,5.998-5.854l.002-.146H6l.002.146Zm14.99,13.73c-.415-3.645-4.277-6.876-8.992-6.876s-8.577,3.231-8.992,6.876c-.032.285.053.571.243.786.189.215.463.338.75.338h16c.287,0,.56-.123.75-.338.19-.215.275-.501.243-.786Z" />
    </svg>
  );
};

export default Employee;
